export default "__VITE_ASSET__39952c26__"